import { createFileRoute } from "@tanstack/react-router"
import { ReceivedInvitationsList } from "@/components/collaboration/received-invitations-list"
import { SendInvitationForm } from "@/components/collaboration/send-invitation-form"
import { SentInvitationsList } from "@/components/collaboration/sent-invitations-list"
import { Page } from "@/components/page"
import { Typography } from "@/components/ui/typography"

export const Route = createFileRoute("/_authed/_individual/personal/journal-invitations")({
  component: JournalInvitationsPage,
})

function JournalInvitationsPage() {
  return (
    <Page>
      <div className="space-y-8">
        {/* Header */}
        <div>
          <Typography as="h1" size="2xl">
            Journal Invitations
          </Typography>
          <Typography as="p" size="sm" className="text-muted-foreground mt-2">
            Share specific journals with trusted individuals using secure PIN verification. Invitees
            can collaborate on journals without accessing your entire estate.
          </Typography>
        </div>

        {/* Send Invitation Form */}
        <div className="rounded-lg border p-6">
          <Typography as="h2" size="lg" className="mb-4">
            Send Invitation
          </Typography>
          <SendInvitationForm />
        </div>

        {/* Sent Invitations */}
        <div className="rounded-lg border p-6">
          <Typography as="h2" size="lg" className="mb-4">
            Sent Invitations
          </Typography>
          <SentInvitationsList />
        </div>

        {/* Received Invitations */}
        <div className="rounded-lg border p-6">
          <Typography as="h2" size="lg" className="mb-4">
            Received Invitations
          </Typography>
          <ReceivedInvitationsList />
        </div>
      </div>
    </Page>
  )
}
